import React from 'react';

interface StatsCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  delta?: string;
  deltaType?: 'positive' | 'negative' | 'neutral';
  className?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({ icon, label, value, delta, deltaType = 'neutral', className = '' }) => {
  const deltaColor = {
    positive: 'text-success-600 dark:text-success-400',
    negative: 'text-error-600 dark:text-error-400',
    neutral: 'text-slate-500 dark:text-slate-400',
  }[deltaType];

  return (
    <div className={`card p-6 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="p-2.5 bg-primary-500/10 rounded-xl">
          {icon}
        </div>
        {delta && (
          <span className={`text-xs font-semibold ${deltaColor}`}>{delta}</span>
        )}
      </div>
      <p className="text-2xl font-display font-bold text-slate-900 dark:text-white">{value}</p>
      <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{label}</p>
    </div>
  );
};

export default StatsCard;
